import { render } from "./g-card.vue?vue&type=template&id=6753384d&scoped=true"
import script from "./g-card.vue?vue&type=script&lang=js"
export * from "./g-card.vue?vue&type=script&lang=js"

import "./g-card.vue?vue&type=style&index=0&id=6753384d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6753384d"]])

export default __exports__